let _alertRef = null;
let _confirmRef = null;

export const modalService = {
	register(alertRef, confirmRef) {
		_alertRef = alertRef;
		_confirmRef = confirmRef;
	},
	alert() {
		return _alertRef;
	},
	confirm() {
		return _confirmRef;
	},
};
